import { useState, type FormEvent } from "react";
import { useSession } from "../lib/session";
import { Notice } from "../components/bits";

export default function Login() {
  const { signIn } = useSession();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await signIn(username, password);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Anmeldung fehlgeschlagen.");
      setBusy(false);
    }
  }

  return (
    <div className="screen" style={{ display: "flex", flexDirection: "column", justifyContent: "center", minHeight: "100dvh" }}>
      <header style={{ marginBottom: 32 }}>
        <h1 style={{ fontFamily: "var(--font-display)", fontSize: "2.6rem", margin: "0 0 6px", letterSpacing: "-0.03em" }}>
          Conquest
        </h1>
        <p className="muted" style={{ margin: 0 }}>
          Komm irgendwo an. Nimm dir den Ort.
        </p>
      </header>

      <form className="stack" onSubmit={(event) => void submit(event)}>
        <div className="field">
          <label htmlFor="username">Benutzername</label>
          <input
            id="username"
            className="input"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            autoCapitalize="none"
            autoCorrect="off"
            spellCheck={false}
            required
          />
        </div>

        <div className="field">
          <label htmlFor="password">Passwort</label>
          <input
            id="password"
            className="input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
        </div>

        {error ? <Notice tone="error">{error}</Notice> : null}

        <button className="btn btn--block btn--lg" type="submit" disabled={busy}>
          {busy ? <span className="spin" aria-hidden /> : null}
          {busy ? "Anmeldung läuft" : "Anmelden"}
        </button>
      </form>

      <p className="tiny muted" style={{ marginTop: 24, lineHeight: 1.5 }}>
        Conquest hält dich 90 Tage lang angemeldet, damit dich unterwegs nie eine Abmeldung erwischt.
      </p>
    </div>
  );
}
